module.exports = __webpack_public_path__ + "static/media/248-150.88549486.webp";